
import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import ConsumptionLegend from './ConsumptionLegend';

interface ConsumptionAreaChartProps {
  data: any[];
  hideConsumption: boolean;
  onLegendClick: () => void;
  timeRange: 'month' | 'quarter' | 'year';
}

const ConsumptionAreaChart: React.FC<ConsumptionAreaChartProps> = ({ 
  data, 
  hideConsumption, 
  onLegendClick,
  timeRange
}) => {
  const dataKey = timeRange === 'month' ? 'day' : 'month';

  // Custom legend renderer
  const renderLegend = (props: any) => {
    return (
      <ConsumptionLegend 
        hideConsumption={hideConsumption}
        onLegendClick={onLegendClick}
        payload={props.payload}
      />
    );
  };

  // Define unit based on time range
  const getUnit = () => {
    return timeRange === 'month' ? 'kWh' : 'kWh';
  };

  return (
    <div className="h-full w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 5, right: 5, bottom: 5, left: 0 }}
        >
          <defs>
            <linearGradient id="colorConsumption" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#0A84FF" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#0A84FF" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey={dataKey}
            tick={{ fontSize: 10 }}
            axisLine={{ stroke: '#e0e0e0' }}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 10 }}
            axisLine={{ stroke: '#e0e0e0' }}
            tickLine={false}
            width={28}
            tickFormatter={(value) => `${value}${timeRange === 'month' ? '' : 'k'}`}
          />
          <Tooltip
            formatter={(value) => [`${value} ${getUnit()}`, 'Consumption']}
            contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              backgroundColor: 'rgba(255, 255, 255, 0.97)'
            }}
            labelStyle={{ fontWeight: 'bold', marginBottom: '4px' }}
          />
          <Legend 
            content={renderLegend}
            verticalAlign="top" 
            height={24}
          />
          <Area
            type="monotone"
            dataKey="consumption"
            name="Consumption (kWh)"
            stroke="#0A84FF"
            fillOpacity={1}
            fill="url(#colorConsumption)"
            hide={hideConsumption}
            strokeWidth={2}
            activeDot={{ r: 4, strokeWidth: 1, stroke: '#fff' }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ConsumptionAreaChart;
